import * as ReactDOM from "react-dom";
import React from "react";
import App from "./App";

ReactDOM.render(<App/>, document.getElementById("game"));

//Separar entornos: patrones vs publico vs dev
//bug: el randomeo a veces se da en el diome de un upd8
//NTH: animar send fades
//EASY FAP MODE que no randomice las respuestas y la primera siempre sea buena

//Proximo release: all about youuu
//NICE TO HAVE: mandar fotos como imagenes
//NICE TO HAVE: breakear mensajes a enviar en varios (capaz con elipsis)
//SUPER NICE TO HAVE: highlightear mensajes antes y requerir apretar send

//a futuro: checkpoints: poder retroceder al ultimo checkpoint